function NXEmv({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4293_1264)">
        <path
          d="M20.5357 4.60726H2.46427C1.55694 4.60726 0.821411 5.3428 0.821411 6.25012V17.7501C0.821411 18.6575 1.55694 19.393 2.46427 19.393H20.5357C21.443 19.393 22.1786 18.6575 22.1786 17.7501V6.25012C22.1786 5.3428 21.443 4.60726 20.5357 4.60726Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.39281 14.4644C8.75381 14.4644 9.8571 13.3611 9.8571 12.0001C9.8571 10.6391 8.75381 9.53583 7.39281 9.53583C6.03182 9.53583 4.92853 10.6391 4.92853 12.0001C4.92853 13.3611 6.03182 14.4644 7.39281 14.4644Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9643 9.53583H18.0714"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9643 14.4644H18.0714"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4293_1264">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500122)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXEmv;
